module.exports = __webpack_public_path__ + "static/media/W19-0084_Mobile_AW_Banner_EN.b4595e11.jpg";